import { parseISO, formatDistanceToNow } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

const TZ = "Europe/Zurich";

function parse(dateStr) {
  if (!dateStr) return null;
  const d = parseISO(String(dateStr));
  return isNaN(d) ? null : d;
}

/**
 * Swiss-style datetime in Zurich timezone: "04.04.2026 16:23"
 */
export function swissDate(dateStr) {
  const d = parse(dateStr);
  if (!d) return "—";
  return formatInTimeZone(d, TZ, "dd.MM.yyyy HH:mm");
}

export function swissDateShort(dateStr) {
  const d = parse(dateStr);
  if (!d) return "—";
  return formatInTimeZone(d, TZ, "dd.MM.yy");
}

/** Always relative: "3 minutes ago", "2 hours ago" */
export function relativeDate(dateStr) {
  const d = parse(dateStr);
  if (!d) return "—";
  return formatDistanceToNow(d, { addSuffix: true });
}

/**
 * Show relative for <1h, then Swiss format
 */
export function smartDate(dateStr) {
  const d = parse(dateStr);
  if (!d) return "—";
  const diffMs = Date.now() - d.getTime();
  if (diffMs < 60 * 60 * 1000) {
    return formatDistanceToNow(d, { addSuffix: true });
  }
  return swissDate(dateStr);
}
